/**
 * Internal Dependencies
 */
const metadata = {
  name: "multiple-choice",
  supports: {
    editable: true,
    required: true,
    attachment: true,
    description: true,
    logic: true,
    theme: true,
    points: true,
    payments: true,
    choices: true,
    correctAnswers: true
  },
  attributes: {
    choices: {
      type: "array",
      items: {
        type: "object",
        properties: {
          value: {
            type: "string"
          },
          label: {
            type: "string"
          }
        }
      },
      "default": [{
        value: "124e4567e89b",
        label: "Choice 1"
      }]
    },
    max: {
      type: ["number", "boolean"],
      "default": false
    },
    min: {
      type: ["number", "boolean"],
      "default": false
    },
    verticalAlign: {
      type: "boolean",
      "default": false
    },
    multiple: {
      type: "boolean"
    }
  },
  logicalOperators: ["is", "is_not"]
};
const {
  name
} = metadata;
export { name, metadata };
//# sourceMappingURL=index.js.map